import React, { useMemo, useState, useCallback, useEffect } from 'react';

import { Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import { find, isUndefined, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Input } from './components';
import * as S from './styles';

export default function TimeWeek({
  title,
  data,
  onChangeDays,
  desktop,
  tablet,
  mobile,
}) {
  const [daysWeek, setDaysWeek] = useState(data);

  const days = useMemo(
    () => [
      {
        id: 1,
        title: t('s.geral.domingo'),
      },
      {
        id: 2,
        title: t('s.geral.segunda'),
      },
      {
        id: 3,
        title: t('s.geral.terca'),
      },
      {
        id: 4,
        title: t('s.geral.quarta'),
      },
      {
        id: 5,
        title: t('s.geral.quinta'),
      },
      {
        id: 6,
        title: t('s.geral.sexta'),
      },
      {
        id: 7,
        title: t('s.geral.sabado'),
      },
    ],
    []
  );

  const handleChangeDayWeek = useCallback((checked, day) => {
    if (checked) {
      setDaysWeek((state) => [...state, { day }]);
      return;
    }

    setDaysWeek((state) => state.filter((isDay) => isDay.day !== day));
  }, []);

  const handleChangeInput = useCallback((value, id, field) => {
    setDaysWeek((state) =>
      state.map((week) => {
        if (week.day === id) {
          return { ...week, [field]: value };
        }

        return week;
      })
    );
  }, []);

  const handleValidationFullTime = useCallback((value) => {
    if (isUndefined(value) || !value.initial || !value.final) {
      return true;
    }

    const initials = value.initial.split(':').map((val) => Number(val));
    const finals = value.final.split(':').map((val) => Number(val));

    if (finals[0] < initials[0] || value.initial === value.final) {
      return true;
    }

    if (initials[0] === finals[0] && finals[1] < initials[1]) {
      return true;
    }

    if (
      initials[0] > 23 ||
      finals[0] > 23 ||
      finals[1] > 59 ||
      initials[1] > 59
    ) {
      return true;
    }

    return false;
  }, []);

  const week = useMemo(() => {
    return days.map((day, key) => {
      const isTime = find(daysWeek, (state) => state.day === day.id);

      return (
        <S.Week key={key}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isTime}
                onChange={(e) => handleChangeDayWeek(e.target.checked, day.id)}
                name={day.title}
              />
            }
            label={day.title}
          />

          <Input
            label={t('s.geral.horainicial')}
            disabled={!isTime}
            onChangeInput={(value) =>
              handleChangeInput(value, day.id, 'initial')
            }
            defaultValue={isTime ? isTime.initial : null}
          />

          <Input
            label={t('s.geral.horafinal')}
            disabled={!isTime}
            onChangeInput={(value) => handleChangeInput(value, day.id, 'final')}
            error={handleValidationFullTime(isTime)}
            defaultValue={isTime ? isTime.final : null}
          />
        </S.Week>
      );
    });
  }, [daysWeek, days]);

  useEffect(() => {
    if (!isEmpty(daysWeek)) {
      const items = daysWeek.map((w) => ({
        ...w,
        error: handleValidationFullTime(w),
      }));

      if (!isEmpty(items)) onChangeDays(items);
    } else {
      onChangeDays([]);
    }
  }, [daysWeek]);

  return (
    <S.Wrapper>
      {!!title && <Typography>{title}</Typography>}
      <S.WrapperWeeks desktop={desktop} tablet={tablet} mobile={mobile}>
        {week}
      </S.WrapperWeeks>
    </S.Wrapper>
  );
}

TimeWeek.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.number.isRequired,
      initial: PropTypes.string,
      final: PropTypes.string,
    })
  ),
  onChangeDays: PropTypes.func.isRequired,
  desktop: PropTypes.number,
  tablet: PropTypes.number,
  mobile: PropTypes.number,
};

TimeWeek.defaultProps = {
  title: '',
  data: [],
  desktop: 7,
  tablet: 4,
  mobile: 2,
};
